import type { LoanFeatures } from '../types/LoanFeatures';

export const gatekeeperFlags: LoanFeatures = {
    loans: { enabled: true },
    moneyOnClick: { enabled: false },
    loanRepayment: { enabled: true },
    loanInsurance: { enabled: true },
    loanTicketingServices: { enabled: false },
};
